import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AppointmentInput } from 'src/app/core/models/calendar/appointment-input';
import { StorageService } from 'src/app/core/store/storage/storage.service';
import { CalendarFacadeService } from 'src/app/facades/calendar/calendar-facade.service';

@Component({
  selector: 'app-approve-reject',
  templateUrl: './approve-reject.component.html',
  styleUrls: ['./approve-reject.component.scss']
})
export class ApproveRejectComponent implements OnInit {
  appointmentId: any;
  stylistId: any;

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheet: MatBottomSheetRef<ApproveRejectComponent>,
    private calendarFacadeService: CalendarFacadeService,
    private storageService: StorageService) {

    this.appointmentId = data.id;
    const retrievedUserData = this.storageService.getUserData();
    this.stylistId = retrievedUserData.sId;;
  }

  ngOnInit(): void {
  }
  approveRejectAppointment() {
    try {
      let data: AppointmentInput = {
        appointmentId: this.appointmentId,
        isApproved: false,
        updatedBy: this.stylistId
      };
      this.calendarFacadeService.approveAndRejectAppointment(data).subscribe({
        next: (res) => {
          this.bottomSheet.dismiss('success');
        }, error(err) {
          this.bottomSheet.dismiss('False');
        }
      })
    } catch (err) {
      this.bottomSheet.dismiss('False');
    }
  }
  close() {
    this.bottomSheet.dismiss();
  }
}
